import Image, { ImageProps } from "next/image";

/*
 * Partner/sponsor logos served as static SVG assets instead of inline JSX
 * so they are downloaded once and cached, and never bundled into JS chunks.
 * Files live in public/_a/logos (the _a prefix is excluded from the
 * device/country rewrite in src/proxy.ts) and are generated from the
 * original SvgIcons components; width/height match each SVG's intrinsic size.
 */
const LOGOS = {
  PAYTM: { src: "/_a/logos/paytm.svg", width: 245, height: 30, alt: "Paytm" },
  SCHOOL_OF_AI: { src: "/_a/logos/school-of-ai.svg", width: 205, height: 30, alt: "School of AI" },
  HCL_TECH: { src: "/_a/logos/hcl-tech.svg", width: 268, height: 30, alt: "HCLTech" },
  TCS_ION: { src: "/_a/logos/tcs-ion.svg", width: 260, height: 30, alt: "TCS iON" },
  KPMG: { src: "/_a/logos/kpmg.svg", width: 229, height: 30, alt: "KPMG" },
  MEDAVERSITY: { src: "/_a/logos/medaversity.svg", width: 309, height: 30, alt: "Medaversity" },
  BRAIN_STROM: { src: "/_a/logos/brainstrom.svg", width: 32, height: 31, alt: "" },
  RICS: { src: "/_a/logos/rics.svg", width: 220, height: 26, alt: "RICS" },
  WOMEN: { src: "https://static.amityonline.com/_s/Exclusive_Cohort_for_Women_de9033893f.webp", width: 220, height: 26, alt: "WOMEN"}
} as const;

export type SponsoredLogoType = keyof typeof LOGOS;

interface SponsoredLogoProps extends Omit<ImageProps, "src" | "alt"> {
  type: SponsoredLogoType;
}

const SponsoredLogo = ({ type, ...props }: SponsoredLogoProps) => {
  const logo = LOGOS[type];
  if (!logo) return null;
  return (
    <Image
      src={logo.src}
      width={logo.width}
      height={logo.height}
      alt={logo.alt}
      loading="lazy"
      {...props}
    />
  );
};

export default SponsoredLogo;
